<template>
	<div>
		<h1 class="alpha heavy center">Login</h1>
		<form class="mt-2" @submit.prevent="submit">
			<fieldset>
				<div>
					<div class="input-group">
						<label><span>Email </span>
							<input v-model="form.data.email" type="email">
							<div
								v-if="form.errors.get('email') || form.errors.get('credentials')"
								class="error-block">
								<p v-html="form.errors.get('email') || form.errors.get('credentials')"></p>
							</div>
						</label>
						<FormFieldPassword v-model="form.data.password" :error="form.errors.get('password')"/>
					</div>
				</div>
			</fieldset>
			<ul class="actions wide">
				<li>
					<process-button :processing="form.processing" class="button button--primary--wide" text="Login"/>
				</li>
			</ul>
		</form>
		<ul class="sub-actions">
			<li>
				<router-link :to="{name: 'password.requestToken'}" class="heavy">Forgot your password?</router-link>
			</li>
		</ul>
	</div>
</template>
<script>
import FormFieldPassword from "@/components/forms/fields/FormFieldPassword.vue";

export default {
	components: {FormFieldPassword},

	data() {
		return {
			form: this.newForm({
				email: "",
				password: "",
			}).setHttpClient(http(true)),
		};
	},

	methods: {
		async submit() {
			this.form.processing = true;
			await http(true).get("sanctum/csrf-cookie");
			await this.form.continueProcessing().post(window.location.pathname).then((response) => {
				let redirect = response.redirect;
				this.$store.dispatch("authStore/authed").then(() => {
					let url = new URL(redirect);
					this.$router.push({path: this.stringer(url.href).replace(window.endpoints.base, "").value || "/"});
				});
			}).catch(error => {
				if ("AccountUnconfirmed" === error.response.data.error) {
					this.$router.push({name: "register.confirm"});
				}
			});
		},
	},
};
</script>
